import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { ModalOutletComponent } from './modal-outlet.component';
import { ModalDirective } from './modal.directive';

@NgModule({
  declarations: [ModalComponent, ModalOutletComponent, ModalDirective],
  imports: [CommonModule],
  exports: [ModalOutletComponent],
})
export class ModalModule {}
